import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, useLocation, useHistory } from "react-router-dom";
import Header from "views/Header";
import Footer from "views/Footer";
import Logout from "views/Logout";
import Ceo from "views/CEO";
import Forums from "views/Forums";
import Topics from "views/Topics";
import Discussion from "views/Discussion";
import User from "views/Profile";
import Admin from "views/Admin";
import AdminRoute from "views/AdminRoute";
import AdminImage from "views/AdminImage";
import Register from "views/Register";
import RegisterVerify from "views/Register/verify";
import ContactUs from "views/Register/contact";
import Career from "views/Register/career";
import NotFound from "views/NotFound";
import Attention from "views/Footer/attention";
import Privacy from "views/Footer/privacy";
import TandC from "views/Footer/tandc";
import styles from "./index.module.css";
import { useTranslation } from "react-i18next";
import {
    FORUM_CATEGORY_TYPE_ID_ca,
    FORUM_CATEGORY_TYPE_NAME,
} from "../../constants";
import { UPDATE_APP_FORUMCATEGORYID } from "views/App/constants";
import { Helmet } from "react-helmet";

const { forumNameConfig, siteUrl, supportedLang } = require("../../config");

const App = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    let langCode = useSelector((state) => state.app.lang);
    const [backgroundStyle, setBackgroundStyle] = useState({
        backgroundSize: "contain",
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const cityName = location.pathname.split("/")[1];
    const matchingCategoryId = cityName
        ? Object.keys(FORUM_CATEGORY_TYPE_ID_ca).find(
              (categoryId) =>
                  FORUM_CATEGORY_TYPE_ID_ca[categoryId].toLowerCase() ===
                  cityName.toLowerCase()
          )
        : undefined;
    let forumCategoryId =
        matchingCategoryId !== undefined ? parseInt(matchingCategoryId, 10) : 0;

    let title = "";
    let desc = "";
    let previewImg = "";
    switch (location.pathname.toLowerCase()) {
        default:
            previewImg = "/bgImg/boat.jpg";
            title = "롤로투어 | LoLo Tour";
            desc =
                "캘거리 최고의 한인 프라이빗 투어 여행사 (Calgary's Travel Agency)";
            break;
        case "/" +
            FORUM_CATEGORY_TYPE_ID_ca[
                FORUM_CATEGORY_TYPE_NAME.전부
            ].toLowerCase():
        case "/" +
            FORUM_CATEGORY_TYPE_ID_ca[
                FORUM_CATEGORY_TYPE_NAME.전부
            ].toLowerCase() +
            "/kr":
            previewImg = "/bgImg/boat.jpg";
            title = "롤로투어";
            desc = "캘거리 최고의 한인 프라이빗 투어 여행사 롤로여행사.";
            break;
        case "/" +
            FORUM_CATEGORY_TYPE_ID_ca[
                FORUM_CATEGORY_TYPE_NAME.전부
            ].toLowerCase() +
            "/ca":
            previewImg = "/bgImg/boat.jpg";
            title = "LoLo Tour";
            desc =
                "Calgary's LoLo Tour is the go-to company for private tours.";
            break;
        case "/ceo":
        case "/ceo/kr":
            previewImg = "/bgImg/flight.jpg";
            title = "회사소개";
            desc = "롤로로투어 회사소개입니다.";
            break;
        case "/ceo/ca":
            previewImg = "/bgImg/flight.jpg";
            title = "Our Company";
            desc = "Get to know our company, LoLo Tour better.";
            break;
        case "/register":
        case "/register/kr":
            previewImg = "/bgImg/register.jpg";
            title = "가입하기";
            desc = "롤로로투어에 가입하고 다양한 혜택을 받으세요.";
            break;
        case "/register/ca":
            previewImg = "/bgImg/register.jpg";
            title = "Register";
            desc = "Register & enjoy various benefits from LoLo Tour";
            break;
        case "/contact":
        case "/contact/kr":
            previewImg = "/bgImg/contactus.jpg";
            title = "연락하기";
            desc = "롤로투어에 궁금한점이 있으신가요?";
            break;
        case "/contact/ca":
            previewImg = "/bgImg/contactus.jpg";
            title = "Contact Us";
            desc = "Any questions Lolo Tour can answer?";
            break;
        case "/career":
        case "/career/kr":
            previewImg = "/bgImg/careers.jpg";
            title = "채용정보";
            desc = "롤로투어를 함께 성장시킬분을 모십니다.";
            break;
        case "/career/ca":
            previewImg = "/bgImg/careers.jpg";
            title = "Careers";
            desc = "Join LoLo Tour to grow our company together.";
            break;
    }
    previewImg = siteUrl + previewImg;

    const dynamicRoutes = Object.keys(FORUM_CATEGORY_TYPE_ID_ca).flatMap(
        (categoryId) =>
            supportedLang.flatMap((lang) => [
                <Route
                    exact
                    path={`/${FORUM_CATEGORY_TYPE_ID_ca[categoryId]}${lang}`}
                    component={Forums}
                    key={`${lang}_${categoryId}`}
                />,
            ])
    );

    const isDynamicRoute = Object.keys(FORUM_CATEGORY_TYPE_ID_ca).some(
        (categoryId) => {
            const categoryPath = `/${FORUM_CATEGORY_TYPE_ID_ca[
                categoryId
            ].toLowerCase()}`;
            return (
                location.pathname.toLowerCase() === categoryPath ||
                supportedLang.some(
                    (lang) =>
                        location.pathname.toLowerCase() ===
                        `${categoryPath}${lang.toLowerCase()}`
                )
            );
        }
    );

    useEffect(() => {
        dispatch({
            type: UPDATE_APP_FORUMCATEGORYID,
            forumCategoryId: forumCategoryId,
        });
    }, [location.pathname, forumCategoryId, langCode]);

    const otherRoutes = supportedLang.flatMap((lang) => [
        <Route exact path={`/ceo${lang}`} component={Ceo} />,
        <Route exact path={`/register${lang}`} component={Register} />,
        <Route exact path={`/contact${lang}`} component={ContactUs} />,
        <Route exact path={`/tandc${lang}`} component={TandC} />,
        <Route exact path={`/privacy${lang}`} component={Privacy} />,
        <Route exact path={`/attention${lang}`} component={Attention} />,
        <Route exact path={`/career${lang}`} component={Career} />,
        <Route
            exact
            path={`/${forumNameConfig}/:forumName`}
            component={Topics}
        />,
    ]);

    return (
        <>
            <Helmet>
                <html lang={langCode} />
            </Helmet>
            <Header />
            {title && desc && previewImg && (
                <Helmet>
                    <title>{title}</title>
                    <meta name="og:image" content={previewImg} />
                    <meta name="og:description" content={desc} />
                </Helmet>
            )}

            <div className={styles.appWrap}>
                <div className={styles.appContainer} style={backgroundStyle}>
                    <Switch>
                        <Route exact path={`/`} component={Forums} />
                        <Route
                            exact
                            path={`/${forumNameConfig}/:forumId/:topicId`}
                            component={Discussion}
                        />
                        <Route exact path="/user/:username" component={User} />
                        <Route exact path="/logout" component={Logout} />
                        <Route exact path="/admin/:forumId" component={Admin} />
                        <Route
                            exact
                            path="/admin/route/:forumId"
                            component={AdminRoute}
                        />
                        <Route
                            exact
                            path="/admin/img/:forumId"
                            component={AdminImage}
                        />
                        <Route
                            exact
                            path="/verify"
                            component={RegisterVerify}
                        />
                        {dynamicRoutes}
                        {otherRoutes}
                        <Route path="*" component={NotFound} />
                    </Switch>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default App;
